<template>
    <div>
        <b-navbar :transparent="true" class="mb-5" :close-on-click="false">
            <template #brand>
                    <img :src="logoUrl" alt="iys logo">
            </template>

            <template #end >
                <router-link to="/" custom v-slot="{ navigate }">
                <b-navbar-item href="#" @click="navigate" >
                    <span class="border-bottom px-1" :class='{"is-active":$route.name=="Home"}'>
                    {{$t('consent_list')}}
                    </span>
                </b-navbar-item>
                </router-link>

                <router-link to="/importHistory" custom v-slot="{ navigate }">
                    <b-navbar-item href="#"  @click="navigate" >
                        <span class="border-bottom px-1" :class='{"is-active":$route.name=="ImportHistory"}'>
                        {{$t('import_history')}}
                        </span>
                    </b-navbar-item>
                </router-link>
                
                <b-navbar-item>
                    <b-dropdown
                    position="is-bottom-left"
                    append-to-body
                    aria-role="menu"
                    trap-focus
                    >
                        <template #trigger>
                            <a
                            class="navbar-item px-0"
                            role="button">
                                <b-tag type="is-light is-large" rounded>
                                    <b-icon v-if="name==''" icon="account"></b-icon>
                                    <span v-else>{{ name | getfirstLetter }}</span>
                                </b-tag>
                                <b-icon icon="menu-down"></b-icon>
                            </a>
                        </template>
                        <div class="has-text-centered has-border-bottom-light mb-1">
                            <b-icon icon="account"></b-icon> <span >{{ name }}</span>
                        </div>

                        <!-- Dropdown Elements added -->
                        <router-link to="/brandSettings">
                            <b-dropdown-item aria-role="listitem"><b-icon icon="cog" size="is-small"></b-icon> {{$t('dropdown_settings')}}</b-dropdown-item>
                        </router-link>
                        <b-dropdown-item aria-role="listitem" @click="logout"><b-icon icon="logout" size="is-small"></b-icon> {{$t('logout')}}</b-dropdown-item>
                        
                    </b-dropdown>
                    
                </b-navbar-item>
                
            </template>
    </b-navbar>
    </div>
</template>
<script>
import {mapActions} from 'vuex'

export default {
    name:'Header',
    data() {
        return {
            logoUrl: "/static/images/Logo.svg",
            langs : [{"value":"tr","label":this.$t('lang_tr')},{"value":"en","label":this.$t('lang_en')}],
            name:''
        }
    },
    filters:{
        getfirstLetter:function(name){
            console.log(name)
            name = name.toString()
            return name.charAt(0).toUpperCase()
        }
    },
    methods: {
        ...mapActions(['logoutUser']),
        logout(){
            this.logoutUser().then((response) => {
                console.log('--logoutUser success response')
                console.log(response)
            }).catch(e => {
                console.log('--logoutUser Error')
                console.log(e)
            })
        },
    },
    mounted() {
        this.name = localStorage.getItem('name')
        console.log("this.$route")
        console.log(this.$route)
    }
}
</script>
<style scoped>
    .border-bottom.is-active{
        border-bottom:3px solid #0B5FFF;
    }
</style>


// WEBPACK FOOTER //
// src/components/Header.vue